// extracted by mini-css-extract-plugin
module.exports = {"spinner":"guestLayout_spinner__1JP-C"};